<template>
  <div class="container">
    <label id="drag-drop-area" for="stockCsvFile" @drop.prevent="dropFile" @dragover.prevent>
      <input type="hidden" name="_method" value="stockFileUpload" />
      <slot name="caption"></slot>
      <input id="stockCsvFile" type="file" class="form-control mt10"
        name="csvfile" size="30" v-on:change="onFileChange" /><br />
      <!-- <p>ファイルサイズ：<span class="filesize"></span>Mbyte</p> -->
      <p class="filename">{{ selectedFileName }}</p>
      <p class="okMsg">{{ okMessage }}</p>
      <p class="ngMsg">{{ ngMessage }}</p>
      <input id="uploadBtn" type="text" class="btn btn-lg btn-primary btn-block" v-model="btnName"
      v-on:click="clickBtn" v-bind:disabled="btnDisable"/>
    </label>
  </div>
</template>

<script>
export default {
  name: 'RfidFileUploadArea',
  btnDisable: true,
  props: {
    btnName: {
      type: String,
      default: 'ボタン'
    }
  },
  data () {
    return {
      btnDisable: true,
      selectedFileName: '',
      okMessage: '',
      ngMessage: ''
    }
  },

  mounted () {
    this.$emit('setScreenTitle', this.screenTitle)
  },

  methods: {
    isRequired (item) {
      return this.permissionData[item][this.$session.get('userDiv')] === ''
    },

    // ファイルドロップイベント
    dropFile () {
      if (event.dataTransfer.files.length > 1) {
        this.selectedFileName = ''
        this.selectedFileObj = null
        this.ngMessage = '複数のファイルはアップロードできません。'
        this.refresh()
        // 部品以外の項目との複合条件でボタンの状態を変更する場合は呼び出し元にも通知する必要あり
        this.$emit('btn-click')
        return
      }
      if (this.checkFile(event.dataTransfer.files[0])) {
        this.ngMessage = ''
        this.selectedFileName = event.dataTransfer.files[0].name
        this.selectedFileObj = event.dataTransfer.files[0]
        this.refresh()
        // 部品以外の項目との複合条件でボタンの状態を変更する場合は呼び出し元にも通知する必要あり
        this.$emit('btn-click')
      }
    },

    // 選択したファイル名表示
    onFileChange (event) {
      if (event.target.files[0] !== undefined) {
        if (this.checkFile(event.target.files[0])) {
          this.ngMessage = ''
          this.selectedFileName = event.target.files[0].name
          this.selectedFileObj = event.target.files[0]
          this.refresh()
          this.$emit('btn-click')
        }
      }
    },

    checkFile (file) {
      if (file !== undefined) {
        // 拡張子チェック
        if (!/^.*\.csv$/ig.test(file.name)) {
          this.selectedFileName = ''
          this.selectedFileObj = null
          this.ngMessage = '拡張子は「csv」にしてください。'
          this.refresh()
          // 部品以外の項目との複合条件でボタンの状態を変更する場合は呼び出し元にも通知する必要あり
          this.$emit('btn-click')
          return false
        }
        // ファイルサイズチェック
        var fileSize = (file.size / 1048576).toFixed(4)
        if (fileSize >= 3) {
          this.selectedFileName = ''
          this.selectedFileObj = null
          this.ngMessage = 'アップロードできるファイルサイズは3.0 Mbyte以下です。'
          this.refresh()
          // 部品以外の項目との複合条件でボタンの状態を変更する場合は呼び出し元にも通知する必要あり
          this.$emit('btn-click')
          return false
        } else if (file.size === 0) {
          this.selectedFileName = ''
          this.selectedFileObj = null
          this.ngMessage = 'ファイルサイズが0バイトのため、アップロードできません。'
          this.refresh()
          // 部品以外の項目との複合条件でボタンの状態を変更する場合は呼び出し元にも通知する必要あり
          this.$emit('btn-click')
          return false
        } else {
          // 1バイト以上3MB以下(正常)
          return true
        }
      }
    },

    clickBtn () {
      this.$emit('btn-click', this.selectedFileObj)
    },

    setOkMessage (str) {
      this.okMessage = str
    },
    setNgMessage (str) {
      this.ngMessage = str
    },
    getFileName () {
      return this.selectedFileName
    },
    refresh () {
      // 部品単体ではファイルが選択されている場合のみボタンを活性化する
      if (this.selectedFileName !== '') {
        this.btnDisable = false
      } else {
        this.btnDisable = true
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .okMsg {
    text-align:center;color:#0000ff;
  }
  .ngMsg {
    text-align:center;color:#ff0000;
  }
</style>



// WEBPACK FOOTER //
// src/components/atoms/RfidFileUploadArea.vue